/* =========================================================
   The QUESTION Method — behavior
   Vanilla port of the landing page logic. Runs on load.
   Selectors/IDs/classes match the markup exactly so every
   animation behaves as designed.
   ========================================================= */
(function () {
  function init() {
    var root = document;

    /* ---- Hero chat thread replay loop ---- */
    var chat = root.getElementById('qm-chat');
    var typing = root.getElementById('qm-typing');
    if (chat) {
      var msgs = Array.prototype.slice.call(chat.querySelectorAll('.qm-msg'));
      msgs.forEach(function (m) {
        m.style.opacity = '0';
        m.style.transform = 'translateY(12px) scale(.96)';
        m.style.transition = 'opacity .4s ease, transform .4s ease';
      });
      var i = 0;
      var showTyping = function (cb, side) {
        if (!typing) return cb();
        typing.style.display = 'block';
        typing.style.alignSelf = side === 'out' ? 'flex-end' : 'flex-start';
        setTimeout(function () { typing.style.display = 'none'; cb(); }, 780);
      };
      var step = function () {
        if (i >= msgs.length) {
          setTimeout(function () {
            msgs.forEach(function (m) { m.style.opacity = '0'; m.style.transform = 'translateY(12px) scale(.96)'; });
            i = 0;
            setTimeout(step, 700);
          }, 3200);
          return;
        }
        var m = msgs[i];
        var side = m.getAttribute('data-side');
        var reveal = function () {
          m.style.opacity = '1';
          m.style.transform = 'translateY(0) scale(1)';
          i++;
          setTimeout(step, side === 'note' ? 400 : 640);
        };
        if (side === 'note') reveal();
        else showTyping(reveal, side);
      };
      setTimeout(step, 600);
    }

    /* ---- Scroll reveal ---- */
    var reveals = Array.prototype.slice.call(root.querySelectorAll('[data-reveal]'));
    reveals.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(26px)';
      el.style.transition = 'opacity .8s cubic-bezier(.2,.8,.2,1), transform .8s cubic-bezier(.2,.8,.2,1)';
    });
    if ('IntersectionObserver' in window) {
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.style.opacity = '1'; e.target.style.transform = 'translateY(0)'; ro.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      reveals.forEach(function (el) { ro.observe(el); });
    } else {
      reveals.forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'none'; });
    }

    /* ---- Progress bar + nav + sticky + date-arc fill ---- */
    var progress = root.getElementById('qm-progress');
    var nav = root.getElementById('qm-nav');
    var sticky = root.getElementById('qm-sticky');
    var hero = root.getElementById('qm-hero');
    var arcfill = root.getElementById('qm-arcfill');
    var arcSection = arcfill ? arcfill.closest('section') : null;

    var onScroll = function () {
      var st = window.scrollY;
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      var ratio = docH > 0 ? st / docH : 0;
      if (progress) progress.style.width = (ratio * 100).toFixed(2) + '%';
      if (nav) {
        if (st > 40) {
          nav.style.background = 'rgba(11,10,9,0.94)';
          nav.style.borderBottomColor = 'rgba(255,255,255,0.08)';
          nav.style.backdropFilter = 'blur(10px)';
          nav.style.webkitBackdropFilter = 'blur(10px)';
        } else {
          nav.style.background = 'rgba(11,10,9,0)';
          nav.style.borderBottomColor = 'rgba(255,255,255,0)';
          nav.style.backdropFilter = 'blur(0px)';
          nav.style.webkitBackdropFilter = 'blur(0px)';
        }
      }
      if (arcfill && arcSection) {
        var r = arcSection.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = (vh * 0.8 - r.top) / (r.height * 0.6);
        p = Math.max(0, Math.min(1, p));
        arcfill.style.width = (p * 100).toFixed(1) + '%';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    /* ---- Affiliate CTA override ---- */

    // Your normal Shopify checkout
    const DEFAULT_CTA = "https://www.seduction-lab.com/cart/57333684502915:1";

    // Affiliate links
    const affiliateLinks = {
        themandoctrine: "https://gumroad.com/a/385878115/txafno?wanted=true",
        the_ceo99: "https://gumroad.com/a/1070745699/txafno?wanted=true",
        datingintel: "Https://gumroad.com/a/840906339/txafno?wanted=true",
        // john: "...",
        // mike: "...",
    };

    // Read ?affiliate=name
    const affiliate = new URLSearchParams(window.location.search).get("affiliate");

    // Pick affiliate link or Shopify checkout
    const ctaUrl = affiliateLinks[affiliate] || DEFAULT_CTA;

    // Update every CTA on the page
    root.querySelectorAll(".qm-cta").forEach(function (button) {
        button.href = ctaUrl;
    });

    if (sticky && hero && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { sticky.style.transform = e.isIntersecting ? 'translateY(120%)' : 'translateY(0)'; });
      }, { threshold: 0 });
      so.observe(hero);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
